<template>
  <div>
    <div class="fix-wrapper">
      <breadcrumb
        :crumbs="[
          $t('menu.inventories'),
          $t('action.stockOut') + '：' + shopName,
        ]"
      ></breadcrumb>
      <div class="container">
        <el-form ref="formObjForm" :model="formObj" size="small">
          <div class="pd20">
            <fieldset class="mgb15">
              <legend>{{ $t("text.baseInfo") }}</legend>
              <el-row>
                <!-- <el-col v-if="stockOutTypes.length != 0" :span="8">
                  <el-form-item
                    :prop="'type'"
                    :label="$t('stock.stockOutType')"
                    label-width="80px"
                    :rules="[
                      {
                        required: true,
                        message: $t('rules.required', [
                          $t('stock.stockOutType'),
                        ]),
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-select
                      size="small"
                      v-model="formObj.type"
                      :placeholder="$t('stock.stockOutType')"
                      filterable
                      clearable
                    >
                      <el-option
                        v-for="stockOutType of stockOutTypes"
                        :key="stockOutType"
                        :label="stockOutType"
                        :value="stockOutType"
                      />
                    </el-select>
                  </el-form-item>
                </el-col> -->
                <el-col :span="16">
                  <el-form-item
                    :prop="'remark'"
                    :label="$t('text.batchRemark')"
                    label-width="80px"
                  >
                    <el-input
                      size="small"
                      v-model.trim="formObj.remark"
                      :placeholder="$t('text.batchRemark')"
                      @blur="blurRemark"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </fieldset>
            <fieldset class="mgb15">
              <legend>
                {{ $t("menu.products") }}
                <el-select
                  style="width: 200px"
                  size="mini"
                  v-model.trim="productNoTotal"
                  filterable
                  remote
                  :loading="productsLoading"
                  :placeholder="$t('placeholder.productNoMatchingInv')"
                  :remote-method="querySearchProductNoMatching"
                  @change="handleSelectProductNoMatching"
                >
                  <el-option
                    v-for="product in products"
                    :key="product.productNo"
                    :label="product.productNo"
                    :value="product.productNo"
                  />
                </el-select>
              </legend>
              <div
                v-for="(item, index) in formObj.items"
                :key="index"
                :class="
                  index == formObj.items.length - 1 ? '' : 'border-bottom mgb10'
                "
              >
                <el-row :gutter="10">
                  <el-col :span="4">
                    <el-form-item>
                      <el-select
                        size="small"
                        v-model.trim="item.productNo"
                        filterable
                        remote
                        :loading="productsLoading"
                        :placeholder="
                          $t('rules.mustFill', [$t('product.productNo')])
                        "
                        :remote-method="querySearchProductNo"
                        @change="handleSelectProductNo(index)"
                      >
                        <el-option
                          v-for="product in products"
                          :key="product.productNo"
                          :label="product.productNo"
                          :value="product.productNo"
                        />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="3">
                    <el-form-item>
                      <div
                        v-if="item.productNo == null"
                        class="div-input font12"
                      >
                        {{ $t("product.color") }}：{{
                          $t("prompt.placeSelectProductNo")
                        }}
                      </div>
                      <div v-else>
                        <el-select
                          size="small"
                          v-model="item.color"
                          :placeholder="$t('product.color')"
                          filterable
                          clearable
                          @change="checkExist(index)"
                        >
                          <el-option
                            v-for="(color, idx) in item._productNoColors"
                            :key="idx"
                            :label="color"
                            :value="color"
                          />
                        </el-select>
                      </div>
                    </el-form-item>
                  </el-col>
                  <el-col :span="3">
                    <el-form-item>
                      <div
                        v-if="item.productNo == null"
                        class="div-input font12"
                      >
                        {{ $t("product.size") }}：{{
                          $t("prompt.placeSelectProductNo")
                        }}
                      </div>
                      <div v-else>
                        <el-select
                          size="small"
                          v-model="item.size"
                          :placeholder="$t('product.size')"
                          filterable
                          clearable
                          @change="checkExist(index)"
                        >
                          <el-option
                            v-for="(size, idx) in item._productNoSizes"
                            :key="idx"
                            :label="size"
                            :value="size"
                          />
                        </el-select>
                      </div>
                    </el-form-item>
                  </el-col>
                  <el-col :span="3">
                    <el-form-item>
                      <el-input
                        size="small"
                        v-model.trim="item.quantity"
                        :placeholder="$t('text.quantity')"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item>
                      <el-input
                        v-model="item.remark"
                        :placeholder="$t('text.remark')"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="3">
                    <el-form-item>
                      <span class="font10">
                        {{ $t("inventory.invLockQty") }}:{{ item._quantity }}/{{
                          item._customQuantity
                        }}
                      </span>
                    </el-form-item>
                  </el-col>
                  <el-col
                    :span="3"
                    v-if="item._invNotExistFg || item._localRepeatFg"
                  >
                    <el-form-item>
                      <small v-if="item._invNotExistFg" class="red">{{
                        $t("prompt.outInvInfoNotExist")
                      }}</small>
                      <small
                        v-if="item._invNotExistFg && item._localRepeatFg"
                        class="red"
                        >/</small
                      >
                      <small v-if="item._localRepeatFg" class="red">{{
                        $t("prompt.hasBeenSelectProduct")
                      }}</small>
                    </el-form-item>
                  </el-col>
                  <el-col v-if="index" :span="1">
                    <el-form-item>
                      <i class="el-icon-delete red" @click="remove(index)" />
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
              <el-row :gutter="10">
                <el-col :span="6"
                  >{{ $t("stock.totalQuantity") }}:
                  {{ computeTotalQuantity() }}</el-col
                >
              </el-row>
              <div class="center">
                <el-button
                  v-if="formObj.items.length < 10"
                  type="info"
                  @click="addMore"
                  plain
                  round
                  >{{ $t("action.addProduct") }}</el-button
                >
                <span v-else class="orange">
                  {{ $t("prompt.addMorePrompt") }}
                </span>
              </div>
            </fieldset>
          </div>
          <div class="form-footer">
            <el-button
              type="primary"
              size="medium"
              plain
              :loading="saveDoing"
              @click="saveSubmit"
              >{{ $t("text.submit") }}</el-button
            >
            <back-button />
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import { page } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import BackButton from "@/components/BackButton";
import Product from "@/api/product.js";
import Inventory from "@/api/inventory.js";
import StockInOut from "@/api/stockInOut.js";

function bulid() {
  return {
    type: "other",
    inventoryId: null,
    productNo: null,
    color: null,
    size: null,
    remark: null,
    shopId: null,
    _invNotExistFg: false,
    _localRepeatFg: false,
    _productNoColors: [],
    _productNoSizes: [],

    _quantity: 0,
    _customQuantity: 0,
    _maxQuantity: 0,
  };
}

export default {
  mixins: [page],
  components: { BackButton },
  data() {
    return {
      Util: Util,
      shops: [],
      shopId: null,
      shopName: null,
      stockOutTypes: [],
      formObj: {
        type: null,
        remark: null,
        items: [bulid(), bulid(), bulid()],
      },
      products: [],
      productsLoading: false,
      saveDoing: false,
      //
      productNoTotal: null,
    };
  },

  computed: {},
  created() {
    const self = this;
    self.shopId = self.$route.params.shopId;
    self.shopName = self.$route.query.shopName;
    //出入库类型
  },
  methods: {
    blurRemark() {
      const self = this;
      for (const item of self.formObj.items) {
        if (item.remark == null) {
          item.remark = self.formObj.remark;
        }
      }
    },
    computeTotalQuantity() {
      let totalQuantity = 0;
      if (this.formObj.items.length !== 0) {
        for (const item of this.formObj.items) {
          totalQuantity = totalQuantity + Number(item.quantity || 0);
        }
      }
      return totalQuantity;
    },

    querySearchProductNoMatching(queryString, cb) {
      const self = this;
      if (queryString == null || queryString.length < 1) {
        return;
      }
      this.productsLoading = true;
      Product.vagueFindByProductNo({
        productNo: queryString,
        type: "product",
      }).then(function (res) {
        self.products = res.data;
        self.productsLoading = false;
      });
    },

    handleSelectProductNoMatching() {
      const self = this;
      const item = this.products.find(
        (p) => p.productNo === self.productNoTotal
      );
      Inventory.findByNoAndShop({
        shopId: self.shopId,
        productNo: self.productNoTotal,
      }).then(function (res) {
        if (res.status === 200) {
          const records = res.data;
          if (records.length == 0) {
            self.$message({
              message: self.$t("inventory.inventoryInfoNoExist"),
              type: "warning",
            });
            return;
          }
          self.formObj.items = [];
          for (const r of records) {
            self.formObj.items.push({
              inventoryId: r.id,
              productNo: r.productNo,
              color: Util.jyTrim(r.color),
              size: Util.jyTrim(r.size),
              quantity: null,
              remark: self.formObj.remark,
              shopId: self.shopId,
              _productNoColors: item.colors || [],
              _productNoSizes: item.sizes || [],
              _invNotExistFg: false,
              _localRepeatFg: false,
              _quantity: r.quantity,
              _customQuantity: r.customQuantity,
              _maxQuantity: r.quantity - r.customQuantity,
            });
            if (self.formObj.items.length == 10) {
              return;
            }
          }
        } else {
          self.$message({
            message: self.$t("inventory.inventoryInfoNoExist"),
            type: "warning",
          });
        }
      });

      self.productNoTotal = null;
    },

    querySearchProductNo(queryString, cb) {
      const self = this;
      if (queryString == null || queryString.length < 1) {
        return;
      }
      this.productsLoading = true;
      Product.vagueFindByProductNo({
        productNo: queryString,
        type: "product",
      }).then(function (res) {
        self.products = res.data;
        self.productsLoading = false;
      });
    },
    handleSelectProductNo(index) {
      const item = this.products.find(
        (p) => p.productNo === this.formObj.items[index].productNo
      );
      this.formObj.items[index]._productNoColors = item.colors || [];
      this.formObj.items[index]._productNoSizes = item.sizes || [];
      this.formObj.items[index].size = null;
      this.formObj.items[index].color = null;
      this.checkExist(index);
    },
    checkExist(index) {
      const self = this;
      self.formObj.items[index].inventoryId = null;

      self.formObj.items[index]._invNotExistFg = false;
      self.formObj.items[index]._localRepeatFg = false;
      self.formObj.items[index].shelfs = [];
      const searchObj = {
        shopId: self.shopId,
        productNo: self.formObj.items[index].productNo,
        color: Util.jyTrim(self.formObj.items[index].color),
        size: Util.jyTrim(self.formObj.items[index].size),
      };
      Inventory.findByProductInfo(searchObj).then(function (res) {
        if (res.data.code === 200) {
          self.formObj.items[index].inventoryId = res.data.entity.id;
          self.formObj.items[index]._quantity = res.data.entity.quantity;
          self.formObj.items[index]._customQuantity =
            res.data.entity.customQuantity;
          self.formObj.items[index]._maxQuantity =
            res.data.entity.quantity - res.data.entity.customQuantity;
        } else {
          self.formObj.items[index]._invNotExistFg = true;
          self.formObj.items[index].inventoryId = null;
        }
        return;
      });
      // 前台本地过滤
      const iis = self.formObj.items.filter(function (ii) {
        return (
          ii.productNo === self.formObj.items[index].productNo &&
          ii.color === self.formObj.items[index].color &&
          ii.size === self.formObj.items[index].size
        );
      });
      if (iis.length > 1) {
        self.formObj.items[index]._localRepeatFg = true;
        return;
      }
    },
    addMore() {
      const bulidNew = bulid();
      bulidNew.remark = this.formObj.remark;
      this.formObj.items.push(bulidNew);
    },
    remove(index) {
      this.formObj.items.splice(index, 1);
    },
    saveSubmit() {
      const self = this;

      self.$refs.formObjForm.validate((valid) => {
        if (valid) {
          const items = JSON.parse(JSON.stringify(self.formObj.items)).filter(
            (item) =>
              item.productNo != null &&
              item.productNo !== "" &&
              item.quantity != null &&
              item.quantity !== ""
          );
          if (items.length === 0) {
            self.$message({
              message: self.$t("prompt.atLeastOneDataFill"),
              type: "warning",
            });
            return;
          }
          for (const item of items) {
            if (item._localRepeatFg === true || item._invNotExistFg == true) {
              self.$message({
                message: self.$t("prompt.errorMessage"),
                type: "warning",
              });
              return;
            }
            if (!Util.regexQuantity(item.quantity)) {
              self.$message({
                message: self.$t("rules.regex", [self.$t("text.quantity")]),
                type: "warning",
              });
              return;
            }
            if (item.quantity > item._maxQuantity) {
              self.$message({
                message:
                  "货号 " + item.productNo + " 出库数量合计大于可出库数量",
                type: "warning",
              });
              return;
            }
            item.type =
              self.formObj.type === null ? "other" : self.formObj.type;
            item.shopId = self.shopId;
            item.color = Util.jyTrim(item.color);
            item.size = Util.jyTrim(item.size);
          }
          self.saveDoing = true;
          StockInOut.batchOut(items).then(function (res) {
            if (res.status === 200) {
              self.saveDoing = false;
              self.sysResults(res.data, self.$t("prompt.stockOutSuccess"));
              self.$router.push({ name: "wmsInventories" });
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>